export const dateFormats = {
    MMDDYYYY: 'MMDDYYYY',
    MMYYYY: 'MMYYYY',
};
